/**
 * Users migrated to Topcon Identity sign in through Topcon Suite only: their
 * FLEET password was locked, and FLEET refuses every way of setting it again.
 */
export const IDENTITY_MIGRATION = {

  /** errorCode of every refusal, so the frontend can show the Topcon Suite dialog. */
  ERROR_CODE: "IDENTITY_MIGRATED",

  /** Where the migrated user signs in and resets the password. */
  PORTAL_URL: "https://topconsuite.io"

} as const;
